// this is an autogenerated file from DesignSystem/LedgerPaymentAccount/PersonPaymentAccount/Payor/Person/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_LedgerPaymentAccount_PersonPaymentAccount_Payor_Person_Content($person_id: numeric!, $patient_person_id: numeric!) {
  vaxiom_persons_by_pk(id: $person_id) {
    id
    _id
    gender
    greeting
    first_name
    last_name
    profile_pic_url
    birth_date
    from_person_relationships(
      where: { to_person: { _eq: $patient_person_id } }
    ) {
      id
      type
      role
    }
    public_user {
      id
      account {
        id
        active
        email
      }
    }
    contact_method_associations {
      id
      postal_address {
        id
        address_line1
        address_line2
        city
        state
        zip
      }
      phone {
        id
        number
      }
      email {
        id
        address
      }
    }
  }
}

`